/**
 * App release shown in the top app bar.
 * Patch number is auto-incremented on every commit by scripts/bump_app_version.py
 * (via .githooks/pre-commit and .cursor/hooks).
 */
export const APP_VERSION = '1.0.312';

export function formatAppVersionLabel(): string {
  return `Version ${APP_VERSION}`;
}
